import type { GridList } from "@repo/ui";
import type { AxiosRequestConfig } from "axios";

import { BaseController, BaseGridApi } from "@repo/baseCloud";

import type { DisciplineRow, DisciplinesFilter, DisciplineTraining } from "../models";

export const controller = "Disciplines";

export default class DisciplinesApi {
	static Get = BaseController.GetFn(controller);

	/** Loads the disciplines matching filters */
	static getDisciplines(filter: DisciplinesFilter, config?: AxiosRequestConfig) {
		return DisciplinesApi.Get<GridList<DisciplineRow>>("GetDisciplines", filter, config);
	}

	/** Gets the courses for the Assigned Training filter */
	static getTrainings() {
		return DisciplinesApi.Get<DisciplineTraining[]>("GetTrainings");
	}

	/** Loads saved grid settings for disciplines */
	static loadGridSettings() {
		return BaseGridApi.loadGridSettings(controller, "Disciplines");
	}

	/** Saves grid settings for disciplines. Pass empty string to clear. */
	static saveGridSettings(settingsJson: string) {
		return BaseGridApi.saveGridSettings(controller, "Disciplines", settingsJson);
	}

	static getGridColumns() {
		return BaseGridApi.getGridColumns<any>(controller, "Disciplines");
	}
}
